/**
 * Filtre des cartes de la page « Ordres de réparation » (Actives, En attente, En cours,
 * Archivées) et du filtre « Archivé ». Extrait de InterventionsPage.tsx pour être testé
 * (__tests__/carte-et-recherche.test.ts).
 *
 * Une RECHERCHE PAR NUMÉRO les court-circuite : chercher 394770, c'est vouloir 394770,
 * archivée ou non (le 23/09/2026, la carte « Actives » cachait une OR que la recherche
 * avait trouvée). Une recherche texte, elle, laisse les cartes agir.
 */

export type CarteFiltre = 'all' | 'active' | 'waiting' | 'in_progress' | 'archived';

export function rechercheParNumero(terme: string): boolean {
  return /^\d+$/.test(String(terme ?? '').trim());
}

export interface CritereCarte {
  carte: CarteFiltre;
  filtreArchive: string[];     // valeurs du menu « Archivé » : 'true', 'false'
  recherche: string;
  archivee: boolean;
  appStatus: string | null | undefined;
}

export function passeLaCarte(c: CritereCarte): boolean {
  if (rechercheParNumero(c.recherche)) return true;
  switch (c.carte) {
    case 'active':      return !c.archivee;
    case 'waiting':     return !c.archivee && ['pending', 'scheduled', 'on_hold'].includes(c.appStatus ?? '');
    case 'in_progress': return !c.archivee && c.appStatus === 'in_progress';
    case 'archived':    return c.archivee;
    default:
      // « Toutes » : le menu « Archivé » reprend la main
      return c.filtreArchive.length === 0 ||
        (c.filtreArchive.includes('true') && c.archivee) ||
        (c.filtreArchive.includes('false') && !c.archivee);
  }
}
